module.exports = "/_next/static/images/2134dcd1495c82e723f7834122ae9e32-woman-using-cellphone@1x.jpg.webp";